<template>
	<div :class='openFrom'>
		<base-button 
			text="cancel check"
			@onClick="cancelOrder" 
			classes="def-btn cancel-action-btn uppercase medium border-2" 
			:is-disabled="!isManager"
		/>
		<base-button 
			text="Close Check"
			@onClick="closeOrder"           
			classes="def-btn main-action-btn uppercase medium border-2 icon left" 
			:is-disabled="isWaiterAssist && isWaiterAssist.user.role === 'waiter assist'"
		  imgSrc="closeOrderWh" 
			custom-styles="background-color: #82B941; border-color: #82B941;"
		/>
	</div>
	<cancel-order-modal
		:selectedOrder="selectedOrder"
		ref="cancel-order-modal"
		v-if="showCancelOrderModal"
		@cancelOrder="cancelOrderCallback"
	/>
	<close-order-modal
		:selectedOrder="selectedOrder"
		ref="close-order-modal"
		v-if="showCloseOrderModal"
		@closeModal="close"
		@onModalClose="closeModal"
		@closeOrder="closeOrderCallback"
	/>
</template>

<script>
import CancelOrderModal from "@/components/_modals/CancelOrderModal";
import CloseOrderModal from "@/components/_modals/CloseOrderModal";
import BaseButton from "@/components/_shared/Button.vue";

export default {
	name: "CancelCloseOrder",
	emits: ['closeOrder', 'closeModal', 'onModalClose', 'cancelOrder'],
	components: {BaseButton, CancelOrderModal, CloseOrderModal, },
	props: {
		selectedOrder: {
			type: Object,
			required: true
		},
		openFrom: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			showCloseOrderModal: false,
			showCancelOrderModal: false
		}
	},
	computed: {
		isManager() {
			return this.$store.state.auth.user?.user.role === 'manager';
		},
		isWaiterAssist() {
			return this.$store.state.auth.user;
		}
	},
	methods: {
		closeModal() {
			this.showCloseOrderModal = false;
		},
		close() {
			this.$refs['modal'].close();
		},
		cancelOrderCallback(data) {
			this.$emit('cancelOrder', data);
		},
		closeOrderCallback() {
			this.$emit('closeOrder');
		},
		cancelOrder() {
			if (!this.isManager) {
				return;
			}

			if (!this.selectedOrder.items.length) {
				this.emmiter.emit('cancelOrder', this.selectedOrder);
			} else {
				this.showCancelOrderModal = true;
				this.$nextTick(() => {
					this.$refs['cancel-order-modal'].openModal(this.selectedOrder);
				})
			}
		},
		closeOrder() {
			if (this.isWaiterAssist && this.isWaiterAssist.user.role === 'waiter assist') {} else {
				if (this.selectedOrder.items.length > 0) {
					this.showCloseOrderModal = true;
					this.$nextTick(() => {
						this.$refs['close-order-modal'].openModal();
					})
				}
			}
		}
	}
}
</script>

<style scoped lang="less">
	.orderOptions {
		button{
			width: 373px;
			&:not(:last-child){
				margin-bottom: 24px;
			}
		}
	}

	.selectedOrder {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: nowrap;
			button {
				box-sizing: border-box;
				width: 49%;
					@media (max-width: 1200px) {
						height: 40px;
						font-size: 11px;
					}
			}
	}
</style>